import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import VerifikasiPembayaranService from '../../services/verifikasiPembayaranServices';
import { clearAuth } from 'store/auth';

export const getListVerifikasi = createAsyncThunk(
  'verifikasiPembayaran/list',
  async ({ page, perPage, sort, orderBy, search, month, year, paymentStatus, excludeMonth, excludeYear, newStudentThisMonth }, thunkAPI) => {
    try {
      const response = await VerifikasiPembayaranService.getList(page, perPage, sort, orderBy, search, month, year, paymentStatus, excludeMonth, excludeYear, newStudentThisMonth);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const readVerifikasi = createAsyncThunk('verifikasiPembayaran/read', async (id, thunkAPI) => {
  try {
    const response = await VerifikasiPembayaranService.read(id);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const verifikasiPayment = createAsyncThunk('verifikasiPembayaran/verifikasi', async (id, thunkAPI) => {
  try {
    const response = await VerifikasiPembayaranService.verifikasi(id);
    thunkAPI.dispatch(setMessage({ message: 'Pembayaran berhasil diverifikasi', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changePaymentStatusVerifikasi = createAsyncThunk('verifikasiPembayaran/changePaymentStatus', async (data, thunkAPI) => {
  try {
    const response = await VerifikasiPembayaranService.changePaymentStatus(data.id, data);
    thunkAPI.dispatch(setMessage({ message: 'Status pembayaran berhasil diubah', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], data: null, error: [] };

const verifikasiPembayaranSlice = createSlice({
  name: 'verifikasiPembayaran',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getListVerifikasi.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListVerifikasi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListVerifikasi.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(readVerifikasi.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readVerifikasi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readVerifikasi.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(verifikasiPayment.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(verifikasiPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(verifikasiPayment.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changePaymentStatusVerifikasi.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changePaymentStatusVerifikasi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(changePaymentStatusVerifikasi.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = verifikasiPembayaranSlice;
export default reducer;


